// extracted by mini-css-extract-plugin
module.exports = {"skeletonContainer":"BasketSkeleton_skeletonContainer__VJwg3"};